import React from 'react';
import { Button, Modal } from 'antd';
import ModalAddTreatment from './ModalAddTreatment';
import { deleteData } from '../../helper/api';
import { toast } from 'react-toastify';

function ActionTreatment(props) {
    const { record, trigerFetchData, setTrigerFetchData } = props;
    const [openModalAdd, setOpenModalAdd] = React.useState(false);
    const [openModalDelete, setOpenModalDelete] = React.useState(false);

    const handleDeleteTreatment = () => {
        deleteData(`/treatments/${record.id}`)
            .then((response) => {
                if (response.status === 200) {
                    toast.success('Treatment deleted successfully');
                    setTrigerFetchData(!trigerFetchData);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    return (
        <div style={{ display: "flex", gap: "20px" }}>
             <Modal
                title="Delete"
                open={openModalDelete}
                onOk={() => handleDeleteTreatment()}
                onCancel={() => setOpenModalDelete(false)}
            >
                {/* ARE YOU SURE */}
                <h2>Are you sure want to delete this treatment {record.id}?</h2>
            </Modal>
            <ModalAddTreatment open={openModalAdd} setOpen={setOpenModalAdd} initialData={record} trigerFetchData={trigerFetchData} setTrigerFetchData={setTrigerFetchData} />
            <Button className="items-center flex justify-center text-white bg-blue-400" onClick={() => setOpenModalAdd(true)}>
                Edit
            </Button>
            {/* <Button className="items-center flex justify-center text-white bg-blue-400" danger className="item-center" onClick={() => setOpenModalDelete(true)}>
                Delete
            </Button> */}
        </div>
    );
}

export default ActionTreatment;